export const leftInfo = [
  "age",
  "weight",
  "med",
  "sex",
  "sire",
  "dam",
  "grandDam",
  "owner"
];
